/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals  page_data: true, Drupal: true, YT:true, jQuery:true, TweenMax:true, window:true, navigator:true, TimelineMax:true, Spinner:true, Sector:true, site:true, Power4:true*/

(function ($) {
  // SAVED JS
  'use strict';

  Drupal.behaviors.ModuleUltimateDiamond = {
    attach: function (context, settings) {
      /*
       * @function getInternetExplorerVersion
       * @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
       * @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
       * @returns {Number} -1 if not any IE version, any other number otherwise
       */
      function getInternetExplorerVersion() {
        var rv = -1;
        var ua;
        var re;
        var verStringArr;

        // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
        if (navigator.appName === 'Microsoft Internet Explorer') {
          ua = navigator.userAgent;
          re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');

          if (re.exec(ua) !== null) {
            rv = parseFloat(RegExp.$1);
          }
        } else if (
          navigator.appName === 'Netscape' &&
          navigator.userAgent.indexOf('Trident') > -1
        ) {
          rv = 11;
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
          ua = navigator.userAgent;
          re = new RegExp('Edge/([0-9]{1,}[.0-9]{0,})');
          verStringArr = re.exec(ua);

          if (verStringArr.length !== 0) {
            rv = Math.floor(parseFloat(verStringArr[0].split('/')[1]));
          }
        }

        return rv;
      }

      // /////////////////////////////////
      // BEGIN: Boutique Implementation
      // /////////////////////////////////
      (function () {
        // DOM
        var $window = $(window);
        var $body = $('body');
        var $boutique = $('#ultimate-diamond-v4');
        // LOGIC
        var debug = false;
        var isMobile;
        var isDesktop;
        var isIpad;
        var ieVersion;
        var youtubeAPIReady = false;
        var deeplink;
        var deeplinking = false;
        var MAIN = new Sector();
        var sectionList = [];

        // Customize global sector JS functionality here
        /**
         * @function generateSection
         * @description Generates Sector JS arguments from a given section and options
         * @param {jQuery} $element Section to generate section data JS arguments from
         * @param {object} options  Object to customize this function's functionality
         * @returns {object} Prepared argument for Sector JS
         */
        function generateSection($element, options) {
          var elementId = $element.attr('id');

          if (typeof $element === 'undefined' || $element.length === 0) {
            return;
          }

          options = $.extend({}, options);

          return {
            element: $element,
            load: function () {
              if (debug) {
                console.log(elementId + ': load');
              }

              if (typeof options.load === 'function') {
                options.load.apply(this, arguments);
              }
            },
            unload: function () {
              if (debug) {
                console.log(elementId + ': unload');
              }

              $element.removeClass('active');

              if (typeof options.unload === 'function') {
                options.unload.apply(this, arguments);
              }
            },
            update: function () {
              if (debug) {
                console.log(elementId + ': update');
              }

              if (arguments[0] >= 0.4) {
                $element.addClass('active');
              } else {
                $element.removeClass('active');
              }

              // Do not allow updates if deeplinking
              if (deeplinking) {
                return;
              }

              if (typeof options.update === 'function') {
                options.update.apply(this, arguments);
              }
            },
            deeplink: function () {
              // LOGIC
              var targetOffset = $element.offset().top - $('header').height();

              if (debug) {
                console.log(elementId + ': deeplink');
              }

              deeplinking = true;

              TweenMax.to($window, 0.5, {
                scrollTo: {
                  y: targetOffset,
                  autoKill: false
                },
                onComplete: function () {
                  deeplinking = false;
                }
              });

              // Ensure the deeplinking is "off" after a set time
              window.setTimeout(function () {
                deeplinking = false;
                MAIN.update(true);
              }, 2000);

              if (typeof options.deeplink === 'function') {
                options.deeplink.apply(this, arguments);
              }
            }
          };
        }

        // BEGIN: Deeplink handling
        deeplink = {
          get: function (seperator) {
            var hashRaw = window.location.hash.trim().replace(/^#{1}/, '');
            var hashData;

            if (hashRaw.length === 0) {
              return [];
            }

            hashData = hashRaw.split(
              typeof seperator !== 'string' || seperator.length === 0 ? '/' : seperator
            );

            return hashData.filter(function (data) {
              return data.length > 0;
            });
          },
          set: function (value) {
            var hashString = '';
            var hashValue;
            var h = 0;

            if (typeof value === 'string' || typeof value === 'number') {
              window.location.replace('#/' + value);
            } else if (typeof value === 'object' && value instanceof Array) {
              for (h = 0; h < value.length; h++) {
                hashValue = value[h];

                if (typeof hashValue === 'string' || typeof hashValue === 'number') {
                  hashString += (hashString.length === 0 ? '' : '/') + hashValue;
                }
              }

              window.location.replace('#/' + hashString);
            }
          }
        };
        // END: Deeplink Handling

        // BEGIN: Platform check
        {
          var mobileSize = 767;

          // Initial mobile checks (additional checks will be needed for 'desktop mobile' sizes)
          isMobile =
            typeof site !== 'undefined'
              ? site.client.isMobile
              : /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
                  navigator.userAgent.toLowerCase()
                );
          isDesktop = !isMobile;
          isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
          ieVersion = getInternetExplorerVersion();

          // set classes for desktop/mobile/ipad/ie
          if (isIpad) {
            $body.addClass('ipad desktop'); // iPad shares desktop styling
          } else {
            $body.addClass(isMobile ? 'mobile' : 'desktop');
          }

          if (ieVersion !== -1) {
            $body.addClass('ie');
          }

          if (ieVersion === 9) {
            $body.addClass('ie-9');
          }

          if (isDesktop) {
            isMobile = $(window).width() <= mobileSize;
            if (isMobile) {
              $body.addClass('mobile');
            }
          }
        }
        // END: Platform check

        // This function needs to be global
        /* function onYouTubeIframeAPIReady() {
        $window.trigger('youtube-ready');
      }*/
        // BEGIN: Init
        {
          window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
            youtubeAPIReady = true;
            $window.trigger('youtubeReady');
          };
        }
        // END: Init

        // BEGIN: Events
        {
          // On scroll we update things
          $window
            .on('scroll', function () {
              sectionList = [];
              MAIN.update(true);

              if (sectionList.length !== 0 && !deeplinking) {
                deeplink.set(sectionList[0].attr('id').replace('ultimate_section-', ''));
              }
            })
            .trigger('scroll');
        }
        // END: Events

        var postLoad = function () {
          // Resize handler that should trigger resize handling with a delay after a resize
          var resizeHandler = (function () {
            var resizeTimeout;

            return function () {
              // Do not allow resizeTimeout creation until timer run and resizeTimeout is undefined again
              if (typeof resizeTimeout !== 'undefined') {
                return;
              }

              resizeTimeout = window.setTimeout(function () {
                /*
                 Required for section load, unload, and update functions called by this function
                 There may be additional animations and functionality implemented in those functions that need to be called.
                 Calling this after resize insures that sections "now" in view get updated while sections that are "now" out of view are unloaded
              */

                // Add mobile class if desktop class scales under mobile size
                if ($body.hasClass('desktop')) {
                  if ($window.width() <= mobileSize && !$body.hasClass('mobile')) {
                    if (debug) {
                      console.log('resizeHandler: Desktop gained mobile');
                    }

                    $body.addClass('mobile');
                    isMobile = true;
                    $(window).trigger('desktopGainedMobile');
                  } else if ($window.width() > mobileSize && $body.hasClass('mobile')) {
                    if (debug) {
                      console.log('resizeHandler: Desktop lost mobile');
                    }

                    $body.removeClass('mobile');
                    isMobile = false;
                    $(window).trigger('desktopLostMobile');
                  }
                }

                // Clear timeout for re-creation
                resizeTimeout = undefined;
              }, 500);
            };
          })();

          // on resize update MAIN and update desktop/mobile classes
          $window.resize(resizeHandler).trigger('resize');

          // Trigger postLoad event
          $window.trigger('postLoad');
        };

        // BEGIN: Section 1
        (function () {
          // DOM
          var $self = $boutique.find('#ultimate_section-1');
          var $carousel = $self.find('.carousel');
          var $slides = $carousel.children();
          var $carouselDots = $self.find('.carousel-dots li');
          var $prev = $self.find('.prev');
          var $next = $self.find('.next');
          // LOGIC
          var carouselAnimation;

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          {
            $slides.css({
              opacity: 0,
              display: 'none'
            });

            $carouselDots.find('a:empty').parent().css({ display: 'none' });

            // BEGIN: Slide quickshop functionality
            if (isMobile) {
              (function () {
                // DOM
                var $mpp = $boutique.find('.mpp').first(); // Note: This assumes the MPP follows after this section's content

                if ($mpp.length === 0) {
                  return;
                }

                $self.append($mpp);
                $self.find('.quickshop').each(function () {
                  // DOM
                  var $this = $(this);
                  var $targetQuickshop;
                  // LOGIC
                  var productID = $this.data('product');

                  $targetQuickshop = $mpp.find('[data-product-id=' + productID + ']');
                  $this.data(
                    'quickshop-open',
                    $targetQuickshop.find('.product-brief__button-quickshop')
                  );
                  $this.data(
                    'quickshop-close',
                    $targetQuickshop.find('.product-brief__button-quickshop--close')
                  );
                });

                // Bind events
                $self.find('.quickshop').on('click', function (e, override) {
                  // DOM
                  var $this = $(this);
                  var $quickshopOpen = $this.data('quickshop-open');
                  var $quickshopClose = $this.data('quickshop-close');

                  e.preventDefault();

                  if (
                    ($this.hasClass('active') && typeof override !== 'boolean') ||
                    (typeof override === 'boolean' && !override)
                  ) {
                    $this.removeClass('active');
                    $quickshopClose.trigger('click');
                  } else if (
                    (!$this.hasClass('active') && typeof override !== 'boolean') ||
                    (typeof override === 'boolean' && override)
                  ) {
                    $this.addClass('active');
                    $quickshopOpen.trigger('click');
                  }
                });
              })();
            }
            // END: Slide quickshop functionality
          }
          // END: Init

          // BEGIN: Events
          {
            // Prev button progression
            $prev.on('click', function (e) {
              if (typeof carouselAnimation !== 'undefined') {
                return;
              }

              e.preventDefault();

              $carousel.carouselPrev();
            });

            // Next button progression
            $next.on('click', function (e) {
              if (typeof carouselAnimation !== 'undefined') {
                return;
              }

              e.preventDefault();

              $carousel.carouselNext();
            });

            // Key press progress
            $window.on('keydown', function (e) {
              var key = e.which;

              switch (key) {
                // Left arrow key
                case 37:
                  $prev.trigger('click');
                  break;

                // Right arrow Key
                case 39:
                  $next.trigger('click');
                  break;
              }
            });

            // Swipe controls for carousel progression
            $carousel.swipe({
              swipeLeft: function () {
                $next.trigger('click');
              },
              swipeRight: function () {
                $prev.trigger('click');
              },
              preventDefaultEvents: false,
              threshold: 100
            });

            // Dot nav handling
            $carouselDots
              .on('click', function (e) {
                // DOM
                var $this = $(this);
                // LOGIC
                var index = $this.index();

                e.preventDefault();

                if ($this.hasClass('active') || typeof carouselAnimation !== 'undefined') {
                  return;
                }

                $this.addClass('active').siblings().removeClass('active');

                $carousel.carouselTo(index);
              })
              .first()
              .addClass('active');

            $window
              .on('desktopGainedMobile', function () {
                var $videos = $slides.find('video');

                // Pause all videos in slide
                $videos.each(function () {
                  if (!this.paused) {
                    this.pause();
                  }
                });
              })
              /*
            .on('desktopLostMobile', function() {
              var $activeSlide = $slides.filter('.active');

              $activeSlide.find('video').play();
            })
            */
              .on('postLoad', function () {
                // LOGIC
                var firstLoad = true;

                $slides.css({ display: '' });

                $carousel.el_carousel({
                  debug: debug,
                  increment: '100%',
                  offset: '0%',
                  useGSAP: false,
                  duration: 1.6,
                  ignoreTargets: '',
                  callbackAnimation: function (dir, steps, options) {
                    var _this = this;
                    var defaults = {
                      callback: undefined,
                      debug: false
                    };
                    var increment = this.increment;
                    var offset = this.offset;
                    var unit = this.unit;
                    var s;
                    var $slide;
                    var duration = 1.6;
                    var debug = false;
                    var adjustedIncrement;
                    var adjustedOffset;

                    options = $.extend(defaults, options);

                    if (typeof options !== 'undefined') {
                      debug = typeof options.debug !== undefined ? options.debug : debug;
                    }

                    if (steps !== 0) {
                      _this.oldSlides[0].trigger('slideWillLoseActive'); // Signal that the last slide will lose active after animation
                    }

                    adjustedIncrement =
                      ((_this.$target.width() * (increment / 100) - $(_this.slides[0]).width()) /
                        $(_this.slides[0]).width()) *
                      100;
                    adjustedOffset =
                      ((_this.$target.width() * (offset / 100)) / $(_this.slides[0]).width()) * 100;

                    $carouselDots
                      .eq(this.slides[0].index())
                      .addClass('active')
                      .siblings()
                      .removeClass('active');

                    carouselAnimation = new TimelineMax({
                      paused: true,
                      onComplete: function () {
                        carouselAnimation = undefined;

                        // Position all slides
                        for (s = 0; s < _this.slides.length; s++) {
                          $slide = _this.slides[s];
                          TweenMax.set($slide, {
                            x: (100 + adjustedIncrement) * s + adjustedOffset + unit
                          });
                        }
                      }
                    });
                    if (dir === -1) {
                      TweenMax.set(_this.slides[0], {
                        x: (100 + adjustedIncrement) * -1 + adjustedOffset + unit
                      });
                    } else {
                      TweenMax.set(_this.slides[0], {
                        x: 100 + adjustedIncrement + adjustedOffset + unit
                      });
                    }

                    carouselAnimation
                      .to(this.$target.children(), duration, {
                        x: '+=' + -dir * (100 + adjustedIncrement) + unit,
                        ease: Power4.easeOut
                      })
                      .to(
                        this.$target.children().not(this.slides[0]),
                        duration,
                        {
                          opacity: 0
                        },
                        '-=' + duration
                      )
                      .to(
                        this.slides[0],
                        duration,
                        {
                          opacity: 1
                        },
                        '-=' + duration
                      );

                    if (firstLoad) {
                      firstLoad = false;

                      TweenMax.from(this.slides[0].find('.image-container'), 1.6, {
                        opacity: 0,
                        x: '100%',
                        clearProps: 'all'
                      });
                    }

                    if (!this.slides[0].hasClass('intro')) {
                      this.slides[0].addClass('intro');
                      TweenMax.staggerFromTo(
                        [
                          _this.slides[0].find('.section-header h2, .section-header h1'),
                          _this.slides[0].find('.section-header .subheader'),
                          _this.slides[0].find('.section-shop')
                        ],
                        0.8,
                        { opacity: 0 },
                        {
                          opacity: 1,
                          delay: duration
                        },
                        0.2
                      );
                    }

                    carouselAnimation.play();
                  }
                });
              });

            $self.find('.quickshop').on('click', function (e) {
              // DOM
              var $this = $(this);
              // LOGIC
              var productData = $this.data('full_product_json');

              e.preventDefault();

              if (!isMobile) {
                if (typeof productData === 'undefined') {
                  return;
                }

                if ($this.hasClass('quickshop')) {
                  site.quickshop(productData);
                }
              }
            });
          }
          // END: Events

          MAIN.add(
            generateSection($self, {
              update: function () {
                sectionList.push($self);
              }
            })
          );
        })();
        // END: Section 1

        // BEGIN: Section 2
        (function () {
          // DOM
          var $self = $boutique.find('#ultimate_section-2');
          var $section_2_wrapper = $self.find('.section-header');
          var $section_2_header = $section_2_wrapper.find('h3');
          var $section_2_subhead = $section_2_wrapper.find('p');
          var $watchFilm = $self.find('.watch-the-film');
          var $videoContainer = $boutique.find('.video_container');
          var $videoPlayer = isMobile
            ? $self.find('.mobile-video')
            : $videoContainer.find('#video_player');
          var $closeButton = isMobile ? $self.find('.close') : $videoContainer.find('.close_btn');
          // LOGIC
          var $section_2_animation = new TimelineMax({ paused: true });
          var player;
          var timerPlayerUpdate;
          var introPlayed = false;

          if ($self.length === 0) {
            return;
          }

          function initYoutube() {
            // DOM
            var $youtubeID = $watchFilm.attr('href').split(/(watch\?v=)/g)[2];

            if (youtubeAPIReady) {
              if (typeof player === 'undefined' && $videoContainer.length !== 0) {
                if (typeof $youtubeID === 'undefined') {
                  return;
                }

                player = new YT.Player($videoPlayer[0], {
                  videoId: $youtubeID,
                  playerVars: {
                    autoplay: 0,
                    cc_load_policy: 0,
                    iv_load_policy: 1,
                    color: 'red',
                    controls: isMobile ? 1 : 0,
                    html5: 1,
                    playsinline: 1,
                    rel: 0,
                    modestbranding: 1,
                    showinfo: 1,
                    wmode: 'transparent',
                    enablejsapi: 1
                  },
                  events: {
                    onStateChange: function (e) {
                      // DOM
                      var $scrubber = $videoContainer.find('.inner_scrubber');
                      var $playButton = $videoContainer.find('.play_btn');
                      // LOGIC
                      var animation = new TimelineMax();

                      // Set play to active and start progress update timer
                      if (e.data === 1 || e.data === 3 || e.data === -1) {
                        if (isMobile) {
                          animation
                            .set($self.find('.mobile-video'), { y: '0%' })
                            .to($self.find('.mobile-video'), 0.5, {
                              opacity: 1,
                              display: 'block'
                            })
                            .to(
                              $closeButton,
                              0.5,
                              {
                                opacity: 1,
                                display: 'block'
                              },
                              '0'
                            );
                          player.playVideo();
                        } else {
                          $playButton.addClass('active');

                          clearInterval(timerPlayerUpdate);

                          timerPlayerUpdate = setInterval(function () {
                            var duration = player.getDuration();
                            var currentTime = player.getCurrentTime();
                            var progress = currentTime / duration;

                            $scrubber.css('width', progress * 100 + '%');
                          }, 500);
                        }
                      } else if (e.data === 0 || e.data === -1 || e.data === 2) {
                        if (isMobile && e.data === 0) {
                          $closeButton.trigger('click');
                        } else {
                          $playButton.removeClass('active');
                        }

                        clearInterval(timerPlayerUpdate);
                      }
                    }
                  }
                });

                $watchFilm.data('video', player);
              }
            } else if (debug) {
              console.log('Youtube API not initialized');
            }
          }

          // BEGIN: Init
          {
            initYoutube();

            // BEGIN: Animation
            $section_2_animation.from($self, 0.8, { opacity: 0 }).staggerFrom(
              [$section_2_header, $section_2_subhead, $watchFilm],
              0.8,
              {
                opacity: 0,
                autoAlpha: 0,
                ease: Power4.easeOut
              },
              0.2
            );
            // END: Animation

            // Prep for mobile video animation
            if (isMobile) {
              TweenMax.set($self.find('.mobile-video'), { opacity: 0 });
              TweenMax.set($self.find('.close'), {
                opacity: 0,
                display: 'none'
              });
            }
          }
          // END: Init

          // BEGIN: Events
          {
            // YouTube controls
            $window
              .on('youtubeReady', function () {
                initYoutube();
              })
              .on('scroll', function () {
                var speed = 4;
                var windowOffset = $window.scrollTop();

                $self.css('background-position', '50% -' + windowOffset / speed + 'px');
              });

            $watchFilm.on('click', function (e) {
              // LOGIC
              var player = $(this).data('video');

              e.preventDefault();

              if (isMobile) {
                if (typeof player !== 'undefined' && typeof player.playVideo === 'function') {
                  player.playVideo();
                }
              } else {
                TweenMax.to($videoContainer, 1, {
                  opacity: 1,
                  display: 'table',
                  onComplete: function () {
                    if (typeof player !== 'undefined' && typeof player.playVideo === 'function') {
                      player.playVideo();
                    }
                  }
                });
              }
            });

            // Custom Controls - Play Button
            $('.controls .play_btn').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $parentControlsMask = $this.closest('.controls');
              // LOGIC

              e.preventDefault();

              if ($parentControlsMask.hasClass('hidden')) {
                return;
              }

              if (typeof player !== 'undefined') {
                if (player.getPlayerState() !== 1) {
                  player.playVideo();
                  $this.addClass('active');
                } else {
                  player.pauseVideo();
                  $this.removeClass('active');
                }
              }
            });

            // Custom Controlls - Scrubber
            $('.controls .scrubber-container').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $parentControlsMask = $this.closest('.controls');
              var $scrubber = $videoContainer.find('.inner_scrubber');
              // LOGIC
              var position = e.clientX - $this.offset().left;
              var duration;
              var progress = position / $this.width();

              e.preventDefault();

              if ($parentControlsMask.hasClass('hidden')) {
                return;
              }

              if (typeof player !== 'undefined') {
                duration = player.getDuration();
                player.seekTo(duration * progress);
                $scrubber.css('width', progress * 100 + '%');
              }
            });

            // Custom Controlls - Full Screen
            $('.controls .full_btn').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $parentControlsMask = $this.closest('.controls');
              var $player = $this.closest('.video_wrapper').find('iframe');
              // LOGIC
              var requestFullScreen;

              e.preventDefault();

              if ($player.length === 0 || $parentControlsMask.hasClass('hidden')) {
                return;
              }

              requestFullScreen =
                $player[0].requestFullScreen ||
                $player[0].mozRequestFullScreen ||
                $player[0].webkitRequestFullScreen;
              requestFullScreen.call($player[0]);
            });

            $closeButton.on('click', function (e) {
              // DOM
              var $scrubber = $videoContainer.find('.inner_scrubber');
              // LOGIC
              var timeline = new TimelineMax();

              e.preventDefault();

              player.pauseVideo();

              if (isMobile) {
                timeline
                  .to(
                    $closeButton,
                    0.5,
                    {
                      opacity: 0,
                      display: 'none'
                    },
                    '0'
                  )
                  .to($self.find('.mobile-video'), 0.5, {
                    opacity: 0,
                    display: 'none'
                  });
              } else {
                timeline.to($videoContainer, 1, {
                  opacity: 0,
                  display: 'none'
                });

                $scrubber.css('width', '');
              }
            });
          }
          // END: Events

          MAIN.add(
            generateSection($self, {
              load: function () {
                if (!introPlayed) {
                  introPlayed = true;
                  $section_2_animation.play();
                }
              },
              update: function () {
                sectionList.push($self);
              }
            })
          );
        })();
        // END: Section 2

        // BEGIN: Section 3
        (function () {
          // DOM
          var $self = $('#ultimate_section-3');
          var $group_1 = $self.find('.left');
          var $group_2 = $self.find('.right');
          var $group_3 = $self.find('.center');
          // LOGIC
          var section_3_animation = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          {
            section_3_animation
              .staggerFrom(
                $group_1.children(),
                1,
                {
                  opacity: 0,
                  y: '+=100'
                },
                0.25
              )
              .staggerFrom(
                $group_2.children(),
                1,
                {
                  opacity: 0,
                  y: '+=100'
                },
                0.25
              )
              .staggerFrom(
                $group_3.children(),
                1,
                {
                  opacity: 0,
                  y: '+=100'
                },
                0.25
              );
          }
          // END: Init

          MAIN.add(
            generateSection($self, {
              update: function (visible) {
                sectionList.push($self);

                if (visible > 0.5) {
                  section_3_animation.play();
                }
              }
            })
          );
        })();
        // END: Section 3

        // BEGIN: Section 4 MPP
        (function () {
          // DOM
          var $self = $('#ultimate_section-4');
          var $mpp = $self.find('.mpp-grid');
          // LOGIC
          var section_4_animation = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          {
            // BEGIN: Animation
            section_4_animation.staggerFrom($mpp.children(), 1, {
              opacity: 0,
              y: '+=100'
            });
            // END: Animation
          }
          // END: Init

          MAIN.add(
            generateSection($self, {
              update: function (visible) {
                sectionList.push($self);

                if (visible > 0.5 && !isMobile) {
                  section_4_animation.play();
                }
              }
            })
          );
        })();
        // END: Section 4 MPP

        // BEGIN: Parallax Sections
        (function () {
          // This shouldn't use Sector
          $window.on('scroll', function () {
            // DOM
            var $parallaxSections = $('.ultimate_section-parallax');
            // LOGIC
            var scrollTop = $window.scrollTop();

            $parallaxSections.each(function () {
              // DOM
              var $this = $(this);
              var $image = $this.find('.ultimate_section-parallax-image');
              // LOGIC
              var yPos;
              var progress = 1;
              var sectionHeight = $this.outerHeight();
              var windowHeight = $window.height();

              yPos = Math.abs($image.height() - sectionHeight);

              progress = Math.abs(
                ($this.offset().top - scrollTop - windowHeight) / (sectionHeight + windowHeight)
              );
              // progress = progress < 0 ? 0 : (progress > 1 ? 1 : progress);

              if (progress < 0 || progress > 1) {
                return;
              }

              $image.css({ top: -(yPos * progress) + 'px' });
            });
          });
        })();
        // END: Parallax Sections

        // BEGIN: Preloader
        (function () {
          var $loader = $('#loader');
          var spinnerOptions = {
            lines: 17, // The number of lines to draw
            length: 0, // The length of each line
            width: 5, // The line thickness
            radius: 26, // The radius of the inner circle
            scale: 1, // Scales overall size of the spinner
            corners: 1, // Corner roundness (0..1)
            color: '#fff', // #rgb or #rrggbb or array of colors
            opacity: 0.5, // Opacity of the lines
            rotate: 0, // The rotation offset
            direction: 1, // 1: clockwise, -1: counterclockwise
            speed: 1, // Rounds per second
            trail: 30, // Afterglow percentage
            zIndex: 2e9, // The z-index (defaults to 2000000000)
            className: 'spinner', // The CSS class to assign to the spinner
            top: '50%', // Top position relative to parent
            left: '50%', // Left position relative to parent
            shadow: false, // Whether to render a shadow
            hwaccel: true, // Whether to use hardware acceleration
            position: 'absolute' // Element positioning
          };
          var spinner = new Spinner(spinnerOptions).spin($loader[0]);

          $('img').FreeLoader({
            callback: function () {
              // DOM
              var $deeplinkSection;
              // LOGIC
              var deeplinkData = deeplink.get();

              TweenMax.to($loader, 1, {
                opacity: 0,
                display: 'none',
                onComplete: function () {
                  spinner.stop();

                  postLoad();

                  if (deeplinkData.length !== 0) {
                    $deeplinkSection = $('#ultimate_section-' + deeplinkData[0]);

                    if ($deeplinkSection.length !== 0) {
                      $deeplinkSection.data('section').deeplink();
                    }
                  }
                }
              });
            }
          });
        })();
        // END: Preloader

        // /////////////////////////////
        // BEGIN: Post Init
        // /////////////////////////////
        (function () {
          var tag = document.createElement('script');
          var firstScriptTag;

          tag.src = 'https://www.youtube.com/iframe_api';
          firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // BEGIN: EL Product
          $('#ultimate_section-1, #ultimate_section-4').elproduct({
            target: '.el-product_shop-now, .el-product, .quickshop',
            template: '.hidden-products-markup-to-clone .el-product',
            products: '.el-product_id-list',
            debug: false,
            onSuccess: function () {
              // DOM
              var $subheadings = $('#ultimate_section-4').find('.el-product_rgn-subheading');

              $('#ultimate_section-4')
                .find('.el-product_category')
                .not('.el-product_shop-now')
                .html('Re-Nutriv');

              // Process subheading text by adding a break after 'ultimate diamond'
              $subheadings.each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var subheadingText;

                subheadingText = $this.html();

                subheadingText =
                  subheadingText.substring(0, 'ultimate diamond'.length).trim() +
                  '<br>' +
                  ('ultimate diamond'.length + 1 < subheadingText.length
                    ? subheadingText
                        .substring('ultimate diamond'.length + 1, subheadingText.length)
                        .trim()
                    : '');

                $this.html(subheadingText);
              });
            }
          });
          // END: EL Product
        })();
        // /////////////////////////////
        // END: Post Init
        // /////////////////////////////
      })();
      // /////////////////////////////////
      // END: Boutique Implementation
      // /////////////////////////////////
    }
  };
})(jQuery);
